import { ActionTree, MutationTree } from "vuex";
import { IOrder, IOrderDraftDeleteResponse, IRootState } from "@iloq/shared";
import OrderingApi from "@/api/OrderingApi";
import { Logger } from "@iloq/shared";
import Vue from "vue";
import { handleCommonApiErrors } from "@/api/CommonApiErrorHandler";

const orderingApi = new OrderingApi();
const localStorageKey = "ordersState";

export interface OrdersState {
  orders: IOrder[];
  ordersApplicableForSalesReturns: IOrder[];
}

const initialState: OrdersState = {
  orders: [],
  ordersApplicableForSalesReturns: [],
};

let timer: any = null;

const actions: ActionTree<IRootState, IRootState> = {
  fetchOrders({ commit }): Promise<any> {
    Logger.debug("fetch order action called");

    const fetchOrders = (): Promise<any> =>
      orderingApi
        .fetchOrders()
        .then((data: any) => {
          const res: [] = data;
          if (res && (res as any).indexOf("No orders found") >= 0) {
            commit("setOrderResults", undefined);
            return [];
          }
          commit("setOrderResults", res);
          return res;
        })
        .catch(handleCommonApiErrors);

    if (!timer) {
      timer = setInterval(fetchOrders, 1000 * 60 * 15); // 15 mins
    }

    return fetchOrders();
  },

  fetchOrdersApplicableForSalesReturns({ commit }): Promise<any> {
    const fetchOrders = (): Promise<any> =>
      orderingApi
        .fetchOrdersApplicableForSalesReturns()
        .then((data: any) => {
          const res: [] = data;
          if (res && (res as any).indexOf("No orders found") >= 0) {
            commit("setOrdersApplicableForSalesReturns", undefined);
            return [];
          }
          commit("setOrdersApplicableForSalesReturns", res);
          return res;
        })
        .catch(handleCommonApiErrors);

    if (!timer) {
      timer = setInterval(fetchOrders, 1000 * 60 * 15); // 15 mins
    }

    return fetchOrders();
  },

  deleteOrder(_: any, order: IOrder): Promise<IOrderDraftDeleteResponse> {
    return orderingApi
      .deleteOrderDraft(order)
      .then((data: any) => data)
      .catch(handleCommonApiErrors);
  },

  fetchOrderingShipments(_: any, order: IOrder) {
    return orderingApi.fetchOrderingShipments(order);
  },
};

const mutations: MutationTree<OrdersState> = {
  setOrderResults(state: OrdersState, result: IOrder[]): void {
    localStorage.setItem(localStorageKey, JSON.stringify(result));
    Vue.set(state, "orders", [...result]);
  },
  setOrdersApplicableForSalesReturns(state: OrdersState, orders: IOrder[]): void {
    Vue.set(state, "ordersApplicableForSalesReturns", [...orders]);
  },
};

export const ordersModule = {
  actions,
  mutations,
  state: initialState,
  namespaced: true,
};
